
import React, { Component } from 'react';

import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { MdOutlineCheckBox } from "react-icons/md";

class CheckBoxComponent extends Component 
{
    render()
    {
        var checkedComponent = <MdCheckBoxOutlineBlank/>

        if (this.props.getValue())
            checkedComponent = <MdOutlineCheckBox/>

        return <div onClick={()=>
                    {
                        this.props.revertValue();
                    }}>
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'1%', whiteSpace:'nowrap'}}>
                                <div style={{fontSize:'2rem'}}>
                                    {checkedComponent}
                                </div>
                            </td>
                            <td style={{width:'99%'}}>
                                <div style={{marginTop:'5px', marginLeft:'5px'}}>{this.props.getCaption()}</div>
                                <div className='hint-text' style={{marginLeft:'5px', marginTop:'0px'}}>{this.props.getHints()}</div>
                            </td>
                        </tr>
                        
                    </table>
                </div>
    }
}


export default CheckBoxComponent;